if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantIdInput = this.variantIdInput;
        if (variantIdInput) variantIdInput.disabled = false;
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        this.submitButtonText = this.submitButton.querySelector('span');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        window.addEventListener('pageshow', () => {
          if (!this.submitButton) return;
          this.submitButton.classList.remove('loading', 'is-adding');
          this.submitButton.removeAttribute('aria-disabled');
          const loadingSpinner = this.querySelector('.loading__spinner');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // Grail: plate + gift wrap are separate paid lines. See grail-product-addons.js.
        const addonHost = this.closest('.grail-product-buy-custom')?.querySelector('grail-product-addons');
        let addonItems = null;
        if (addonHost && typeof addonHost.buildCartItems === 'function') {
          const built = addonHost.buildCartItems(formData);
          if (built && built.error) {
            this.error = true;
            this.submitButton.classList.remove('loading', 'is-adding');
            this.submitButton.removeAttribute('aria-disabled');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                message: built.error,
              });
            }
            return;
          }
          if (built && built.items && built.items.length > 1) addonItems = built.items;
        }

        if (addonItems) {
          const payload = { items: addonItems };
          if (this.cart) {
            payload.sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',');
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const bundleIdsNode = this.querySelector('[data-grail-bundle-cart-ids]');
              const errorPayload = {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
                description: response.description,
              };
              if (bundleIdsNode) errorPayload.grailBundleCartIds = bundleIdsNode.textContent;

              const bundleCartConflict =
                window.GrailCartUi &&
                typeof window.GrailCartUi.isBundleCartConflict === 'function' &&
                window.GrailCartUi.isBundleCartConflict(errorPayload);

              if (window.GrailCartUi) {
                window.GrailCartUi.showError(errorPayload);
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, errorPayload);
              }
              this.handleErrorMessage();

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage || bundleCartConflict) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
            if (!response.id && Array.isArray(response.items) && response.items[0]) {
              response.id = response.items[0].variant_id || response.items[0].id;
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            const errorPayload = {
              source: 'product-form',
              productVariantId: formData.get('id'),
              message: 'Unable to add this item to your cart.',
            };
            if (window.GrailCartUi) {
              window.GrailCartUi.showError(errorPayload);
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, errorPayload);
            }
            this.handleErrorMessage();
          })
          .finally(() => {
            if (!this.submitButton) return;
            this.submitButton.classList.remove('loading', 'is-adding');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('is-adding');
            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        const toast = document.getElementById('grail-cart-error-toast');
        const wrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (this.hideErrors || toast || window.GrailCartUi) {
          if (wrapper) wrapper.setAttribute('hidden', '');
          return;
        }

        if (!wrapper) return;
        this.errorMessageWrapper = wrapper;
        this.errorMessage = this.errorMessage || wrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        const defaultLabel =
          this.submitButton.dataset.grailSubmitLabel || window.variantStrings.addToCart;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = defaultLabel;
        }
      }

      get variantIdInput() {
        if (!this.form) return null;
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
